<template>
    <v-container pa-0 ma-0 fluid>
        <v-row>
            <v-col cols="12">
                <h1 class="text-center mb-5">{{$t('components.checks.webcam.title')}}</h1>
              <p class="text-center body-2 pb-2">
                {{$t('components.checks.webcam.uncomfortable')}}
              </p>
                <v-row justify="center">
                    <div class="webcam-container" style="width: 320px; height: 240px;">
                        <transition-group name="fade">
                            <div key="stream" class="webcam-window">
                            <!--    <Webcam webcam-id="test"
                                        :detect-face="!faceFound"
                                        @faces-detected="facesDetected">
                                </Webcam> -->

                              <Webcam webcam-id="test"
                                      :detect-motion="!motionFound"
                                      @motion-detected="motionDetected">
                              </Webcam>
                            </div>
                        </transition-group>
                    </div>
                </v-row>

                <v-row justify="center">
                    <v-autocomplete :items="videoInputDevices"
                                    :value="selectedVideoInputDevice"
                                    @change="setCameraDevice($event)"
                                    class="mb-5 mt-3"
                                    hide-details
                                    item-color="white"
                                    item-text="label"
                                    item-value="deviceId"
                                    :label="$t('components.checks.webcam.webcam')"
                                    light
                                    :no-data-text="$t('components.checks.no_devices')"
                                    prepend-inner-icon="mdi-webcam"
                                    solo
                                    style="max-width: 320px !important;"
                    ></v-autocomplete>
                </v-row>

                <p v-if="!motionFound" class="text-center">
                  <!--{{$t('components.checks.webcam.look')}}-->
                  {{$t('components.checks.webcam.wave')}}
                </p>

                <v-row justify="center">
                    <v-btn :disabled="!motionFound" @click="next()" color="primary">{{$t('general.continue')}}</v-btn>
                </v-row>


            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {configureDevices} from "../../lib/mediaDevices";
    import Webcam from "../../components/webcam/Webcam";

    export default {
        name: "DeviceCheck",
        components: {
            Webcam
        },
        computed: {
            selectedVideoInputDevice() {
                return this.$store.state.media.cameraDevice;
            }
        },
        data() {
            return {
                videoInputDevices: null,
                permission: true,
                faceFound: false,
                motionFound: false,
            }
        },
        mounted() {
            this.listenForPermission();
            this.getSystemDevices();
        },
        methods: {
          listenForPermission(){
            navigator.permissions.query({ name: 'camera' }).then((notificationPerm)=>{
              notificationPerm.onchange = ()=>{
                this.getSystemDevices();
              };
            });
          },
            getSystemDevices() {
                navigator.mediaDevices.enumerateDevices()
                    .then((devices) => {
                            this.videoInputDevices = devices.filter(d => d.kind === 'videoinput');
                            configureDevices(true, false, false);
                        },
                        () => {
                            this.permission = false;
                        });
            },
            setCameraDevice(val) {
                this.faceFound = false;
                this.motionFound = false;
                this.$store.dispatch('media/setCameraDevice', val);
            },
            facesDetected() {
                this.faceFound = true;
            },
            motionDetected() {
              this.motionFound = true;
            },
            next() {
                this.$router.push({name: 'MicCheck'});
            }
        }
    }
</script>

<style scoped>
    .webcam-container {
        position: relative;
        background-color: black;
        border-radius: 10px;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
        overflow: hidden;
    }

    .webcam-container .webcam-window {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .webcam-container .overlay-center {
        font-family: Roboto, sans-serif;
        font-size: 30pt;
        color: white;
        background-color: black;
        opacity: 0.3;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
</style>